exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filters ul li a[data-v-e41fa69c]{padding:0}li a[data-v-e41fa69c]{fill:#adadad;color:#adadad;border:0}li a[data-v-e41fa69c]:hover{fill:#1e1e1c}.active a[data-v-e41fa69c]{color:#1e1e1c;fill:#1e1e1c}.catalog-types[data-v-e41fa69c]{margin-bottom:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e41fa69c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/site/components/catalog-filter/catalog-type-switcher.vue
// module id = aoPf
// module chunks = 5